module.exports = __webpack_public_path__ + "static/commision-img2-78b3ec2216c5f2281ef8c519df2ab67f.jpg";